import { FC, ReactNode } from 'react';
import styles from './Button.module.scss';
import classNames from 'classnames';

interface buttonType {
  info: string;
  filed: string;
  danger: string;
  outline_icon: string;
  outline: string;
  link: string;
  outlineWhite: string;
}

const themes: buttonType = {
  info: styles.info,
  filed: styles.filed,
  outline_icon: styles.outline_icon,
  danger: styles.danger,
  outline: styles.outline,
  link: styles.link,
  outlineWhite: styles.outlineWhite,
};

interface ButtonProps {
  className?: string;
  icon?: boolean;
  firstIcon?: boolean;
  src?: string;
  children: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  size?: 'L' | 'M' | 'S';
  theme: keyof typeof themes;
  width?: string;
  height?: string;
  spanStyle?: any;
  loading?: boolean;
}

export const Button: FC<ButtonProps> = ({
  onClick,
  className,
  children,
  src,
  icon,
  firstIcon,
  disabled,
  theme,
  width = '16',
  height = '16',
  spanStyle,
  size,
  loading = false,
  ...rest
}) => {
  return (
    <div
      onClick={disabled || loading ? undefined : onClick}
      className={classNames(
        styles.btn,
        theme ? themes[theme] : null,
        size ? styles[`btn_${size}`] : styles['btn_M'],
        className,
        (disabled || loading) && styles.btn_disabled,
      )}
      {...rest}>
      {firstIcon && (
        <>
          <img src={src} alt='icon' width={width} height={height} />
        </>
      )}
      <span style={spanStyle}>{children}</span>
      {loading ? (
        <div className={styles.spinner}>
          <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
            <circle
              cx='12'
              cy='12'
              r='10'
              fill='none'
              strokeWidth='3'
              stroke='currentColor'
              strokeDasharray='32'
              strokeLinecap='round'
              className={styles.spinner_circle}
            />
          </svg>
        </div>
      ) : (
        icon && (
          <>
            <img src={src} alt='icon' width={width} height={height} />
          </>
        )
      )}
    </div>
  );
};
